import React from 'react';
import Notices from '../components/Notice/Notices';

const Notice = () => {
    return ( <Notices/> );
}
 
export default Notice;
